import { MatIconModule } from '@angular/material/icon';
import { NavRoute } from '../sidenav/routes';
import { pageTitleMap, pageTranslationKeyMap } from './titles';
import { RouterLink } from '@angular/router';
import { Component, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'md-page-header',
  imports: [MatIconModule, RouterLink, TranslateModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  standalone: true
})
export class PageHeaderComponent {
  title = input<string>('Otsikko');
  icon = input<string>('customer');
  private breadcrumbs$ = signal<NavRoute[]>([]);

  get breadcrumbs(): NavRoute[] {
    return this.breadcrumbs$();
  }

  constructor() {
    const urlSlices = window.location.pathname.split('?').slice(0, 2)[0].split('/');

    const crumbs = urlSlices
      .slice(2)
      .filter(path => path !== 'price')
      .map(path => {
        return {
          label: pageTitleMap[path] ?? path,
          route: `/${path}`,
          translationKey: pageTranslationKeyMap[path] ?? `NAV.${path.toUpperCase()}`
        };
      });

    this.breadcrumbs$.set(crumbs);
    this.breadcrumbs$.update(crumbs => {
      crumbs.pop();
      return crumbs;
    });
  }

  getBreadcrumbRoute(index: number) {
    return `/app/${this.breadcrumbs
      .slice(0, 1 + index)
      .map(breadcrumb => breadcrumb.route)
      .join('/')}`;
  }
}
